import { ExpandMore } from '@mui/icons-material';
import { accordionClasses, Components } from '@mui/material';
import { alpha, Theme } from '@mui/material/styles';

export const MuiAccordion: Components<Theme>['MuiAccordion'] = {
  defaultProps: {
    disableGutters: true,
  },
  styleOverrides: {
    root: () => ({
      marginBottom: 8,
      borderRadius: 4,
      '&::before': {
        display: 'none',
      },
    }),
  },
};

export const MuiAccordionSummary: Components<Theme>['MuiAccordionSummary'] = {
  defaultProps: {
    expandIcon: <ExpandMore />,
  },
  styleOverrides: {
    root: ({ theme }) => ({
      height: 68,
      borderRadius: 4,
      ...theme.typography.h5,
      [`&.${accordionClasses.expanded}`]: {
        bgcolor: alpha(theme.palette.primary.main, 0.2),
      },
    }),
  },
};

export const MuiAccordionDetails: Components<Theme>['MuiAccordionDetails'] = {
  defaultProps: {},
  styleOverrides: {
    root: () => ({
      paddingTop: 12,
    }),
  },
};
